export const systemMessages = {
    page_leave:
        'You are about to leave this page without saving your changes. Do you wish to exit without saving the details?',
};
